import React from 'react'

import { Icon } from '@components/atoms'

import { sliderStyles } from './styles'

const { containerSlider, text } = sliderStyles

export default function SliderLogin() {
	return (
		<div className={containerSlider()}>
			<div>
				<Icon
					className='image-top'
					title='back-top'
					name='back-top'
					width={114}
					height={104}
					fill='none'
				/>
				<img src='assets/svg/login-img.svg' alt='perguntas' />
				<Icon
					className='image-down'
					title='back-down'
					name='back-down'
					width={114}
					height={104}
					fill='none'
				/>
			</div>

			<div className={text()}>
				<h5>Responda também pelo celular</h5>
				<p>
					Baixe o aplicativo Decorando a Lei Seca, responda as questões e tenha
					o Gabarito com a justificativa da questão.
				</p>
			</div>
		</div>
	)
}
